<script lang="ts">
  import { Col, Row } from "sveltestrap";
  import Card from "../../Core/Card.svelte";
  import { DatePicker } from "date-picker-svelte";
</script>

<Col xl="6" class="xl-100 box-col-12">
  <Card cardBodyprops="cal-date-widget">
    <div slot="contentbody" >
      <Row>
        <Col xl="6" xs="12" md="6" sm="6">
          <div class="cal-info text-center">
            <div>
              <h2>24</h2>
              <div class="d-inline-block">
                <span class="b-r-dark pe-3">March</span><span class="ps-3"
                  >2018</span
                >
              </div>
              <p class="f-16">
                There is no minimum donation, any sum is appreciated
              </p>
            </div>
          </div>
        </Col>
        <Col xl="6" xs="12" md="6" sm="6">
          <div class="cal-datepicker">
            <div class="datepicker-here" data-language="en">
              <DatePicker />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </Card>
</Col>
